import * as React from 'react';
import {
    TextField,
    ReferenceManyField,
    NumberField,
    useTranslate,
    SingleFieldList,
    TextInput,
    useLocale, FunctionField
} from 'react-admin';

import useMyStyles from "../../utils/useMyStyles";
import {DateFieldComp, FileInputComp} from "../../_common/CompReact";
import config from "../../utils/config";
// import {fetchJson as httpClient} from "../utils/keycloak";
import {useSelectedColumns} from "@react-admin/ra-preferences";
import {validateFirstName, validateNameRec, validateReq} from "../../_constants/validateTable";
import MyEditableDatagridForReference from "../../_common/MyEditableDatagridForReference";
import PostPagination from "../../_common/PostPagination";
import {Box} from "@mui/material";
import CroppedLongField from "../../_common/CroppedLongField";
import Dialog from "@material-ui/core/Dialog";
// import {nominatimOpenStreetMap, nominatimOpenStreetMapLatLon} from "../../_common/CompForApi/utilsAPI";
import {useEffect, useMemo, useState} from "react";
// import {useForm} from "react-final-form";
import {Button, Typography} from "@material-ui/core";
// import {LinearProgress} from "@mui/material";
import RowFormCustom from "../../_common/DependenciesComp/RowFormCustom";
import {canAccess2} from "../../utils/canAccess2";
import {MyTranslatableInputs} from "../../_common/MyTranslatableInputs";
import {RowForm} from "@react-admin/ra-editable-datagrid";

import {useRecordContext} from 'ra-core';
import {copyToS3bucket} from "../../_common/Transform";


const ListEditForm = (props) => {
    const classes = useMyStyles();
    const {relaited_id, record} = props;
    const translate = useTranslate();
    const locale = useLocale();

    const [openDialog, setOpenDialog] = useState(true);

    const handleSuccess = (response) => {
        console.log('=response===2========>')
        //refresh();
        //window.location.reload();
    };

    return (
        <Dialog
            //fullWidth={true}
            scroll={'body'}
            classes={{
                paper: 'modal_with_product_list',
            }}
            maxWidth={'lg'}
            // onClose={handleDialogCloseCart}
            open={true}
            onClose={() => setOpenDialog(false)}
        >
            <div style={{padding: 16}}>
                <RowFormCustom
                    {...props}
                    openDialog={openDialog}
                    hasBulkActions={false}
                    initialValues={{
                        trade_mark: relaited_id,
                        source: localStorage.getItem('username')
                    }}
                    mutationOptions={{onSuccess: handleSuccess}}
                    //onSuccess={handleSuccess}
                    // transform={transform}
                >
                    <MyTranslatableInputs
                        validate={validateReq}
                        // prompt={promptData.find(x => x.field === 'name')}
                        fullWidth
                        source={'category'}
                        label={translate('Category')}
                    />
                    {/*<FormDataConsumer>
                    {({formData, ...rest}) => {
                        return (
                            <ListEditForm2 {...props} relaited_id={relaited_id} formData={formData} record={record}/>
                        )
                    }}
                </FormDataConsumer>*/}
                </RowFormCustom>

                {record?.id &&
                    <div style={{
                        width: "fit-content",
                        minWidth: 500,
                        marginBottom: 16,
                        marginTop: 16,
                        overflowX: "auto"
                    }}>
                        <Typography variant="h6">{translate('Trade Mark URL')}</Typography>
                        <ReferenceManyField
                            pagination={<PostPagination/>}
                            perPage={12}
                            fullWidth
                            label="Trade Mark URL"
                            reference="zTradeMarksUrl"
                            target="trademark_category"
                            record={{id: record.id}}
                        >

                            <MyEditableDatagridForReference
                                hasBulkActions={false}
                                // canEdit={canEdit}
                                rowClick="edit"
                                classes={{headerCell: classes.headerCell, row: classes.row, rowCell: classes.rowCell}}
                                //noDelete={customer_id !== customerFormId}
                                mutationMode="pessimistic" //Подтвердить удаление
                                undoable
                                createForm={<ListEditForm2 submitOnEnter={false}
                                                           relaited_id={record.id}/>}
                                editForm={<ListEditForm2 submitOnEnter={false}
                                                         relaited_id={record.id}/>}
                                //rowStyle={postRowStyle}
                            >
                                <NumberField source="id" headerClassName={classes.headerShortWidth}/>
                                <Box display={'grid'} label={`${translate('Name')} / URL`}
                                     style={{
                                         maxWidth: '350x',
                                         whiteSpace: 'normal',
                                         wordBreak: 'break-word',
                                     }}
                                >
                                    <TextField emptyText={'-'} source={`name[${locale}]`} label={translate('Name')}/>
                                    <TextField emptyText={'-'} source={`url`} label={translate('URL')}/>
                                </Box>

                                {/*<TextField emptyText={'-'} source={`file`} label={translate('File')}/>*/}
                                <FunctionField
                                    render={(record) => (
                                        <Box
                                            style={{
                                                maxWidth: '350x',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                            }}
                                            label={translate('File')}
                                        >
                                            {record.file
                                                ?
                                                <a href={`${config.apiUrl}files_media/${record.file}`}
                                                   target={"_blank"}>
                                                    {`${record.file}`}
                                                </a>
                                                : '-'
                                            }
                                        </Box>
                                    )}
                                />
                                <Box label={translate('Update')} sortBy={'updated'} display={'grid'}>
                                    <CroppedLongField source="source" long={10} label={translate('Source')}/>
                                    <DateFieldComp source="updated" label={translate('Update')} textAlign={'center'}
                                                   locale={'us'} cellClassName={classes.date_st}/>
                                </Box>
                            </MyEditableDatagridForReference>

                        </ReferenceManyField>

                    </div>
                }
            </div>
        </Dialog>
    )
}

const transformTradeMarkUrl = (data) => {
    data.source = data.source2;
    // data.name = data.name2;
    delete data.source2;
    // delete data.name2;

    return copyToS3bucket('zTradeMarksUrl', data);
}
const ListEditForm2 = (props) => {
    // const {classes, locale} = props;
    const {classes, relaited_id} = props;
    const translate = useTranslate();

    const handleSuccess = (response) => {
        console.log('=response===2========>')
        //refresh();
        //window.location.reload();
    };
    return (
        <RowForm
            {...props}
            hasBulkActions={false}
            initialValues={{
                trademark_category: relaited_id,
                source2: localStorage.getItem('username'),
                //file2: record.file
            }}
            mutationOptions={{onSuccess: handleSuccess}}
            //onSuccess={handleSuccess}
            transform={transformTradeMarkUrl}
        >
            <NumberField source="id" headerClassName={classes.headerShortWidth}/>
            <Box display={'grid'}
                 style={{
                     maxWidth: '350px',
                     whiteSpace: 'normal',
                     wordBreak: 'break-word',
                 }}
            >
                <MyTranslatableInputs
                    validate={validateReq}
                    // prompt={promptData.find(x => x.field === 'name')}
                    fullWidth
                    source={'name'}
                    label={translate('Name')}
                />
                <TextInput
                    source={`url`}
                    label={translate('URL')}
                    // validate={validateFirstName}
                    variant={"outlined"}
                    fullWidth
                />
            </Box>
            <Box
                 style={{
                     maxWidth: '350px',
                     whiteSpace: 'normal',
                     wordBreak: 'break-word',
                 }}
            >
                <FileInputComp
                    source="file"
                    // label="PDF файл"
                    accept="application/pdf"
                    maxSize={5 * 1024 * 1024} // 5MB
                    placeholder={<p>Выберите файл PDF (max 5Mb)</p>}
                />
            </Box>
            <Box label={translate('Update')} sortBy={'updated'} display={'grid'}>
                <CroppedLongField source="source" long={10} label={translate('Source')}/>
                <DateFieldComp source="updated" label={translate('Update')} textAlign={'center'}
                               locale={'us'} cellClassName={classes.date_st}/>
            </Box>
        </RowForm>
    )
};

const ColumnsForList = (resource, classes, locale) => {
    const translate = useTranslate();
    let columns = {
        id: <NumberField source="id" headerClassName={classes.headerShortWidth}/>,

        category: <TextField source={`category[${locale}]`} label={translate('Category')}/>,

        url:
            <ReferenceManyField label="URL" reference="zTradeMarksUrl"
                                target="trademark_category" link={false} sortable={false}>
                <SingleFieldList link={false} style={{display: 'grid', pointerEvents: 'none'}}>
                    {/*<FunctionField link={false}
                                   render={(record) => (
                                       <Box display={'grid'} mt={1}>
                                           <Box>
                                               <span>{`#${record.id} `}</span>
                                               <span>{record?.name[locale] || '-'}</span>
                                           </Box>
                                           <span>{record?.url || '-'}</span>
                                       </Box>
                                   )}
                    />*/}

                    <Box style={{display: 'grid'}} p={'4px'}>
                        <Box>#<TextField source={`id`}/></Box>
                        <TextField emptyText={'-'} source={`name[${locale}]`}/>
                        <TextField emptyText={'-'} source={`url`}/>
                        {/*<TextField emptyText={'-'} source={`file`}/>*/}
                    </Box>
                </SingleFieldList>
            </ReferenceManyField>,

        updated:
            <Box label={translate('Update')} sortBy={'updated'} display={'grid'}>
                <CroppedLongField source="source" long={10} label={translate('Source')}/>
                <DateFieldComp source="updated" label={translate('Update')} textAlign={'center'}
                               locale={'us'} cellClassName={classes.date_st}/>
            </Box>,
    }

    return columns;
};

const RelatedTradeMarks = props => {
    // const {customer_id, record, isSave = true} = props;
    const {relaited_id, resource: from_resource} = props;
    const classes = useMyStyles();
    const locale = useLocale();
    // const redirect = useRedirect()
    //const refresh = useRefresh();

    // let invoiceBooking = useSelector((state) => state.admin.resources.invoice_booking)
    //console.log('resource==!!!=====>', from_resource);

    const columns = useSelectedColumns({
        preferences: `${'partnerAddress'}list.columns`,
        columns: ColumnsForList('tradeMarksCategory', classes, locale),
        omit: ["nb_views"],
    });

    const canEdit = canAccess2({resource: `${from_resource}`, action: 'edit'});
    return (
        <div style={{width: "fit-content", minWidth: 500, marginBottom: 16, overflowX: "auto"}}>
            <ReferenceManyField
                pagination={<PostPagination/>}
                perPage={12}
                fullWidth
                label="Trade Mark Categories"
                reference="zTradeMarksCategory"
                target="trade_mark"
            >

                <MyEditableDatagridForReference
                    canEdit={canEdit}
                    rowClick="edit"
                    classes={{headerCell: classes.headerCell, row: classes.row, rowCell: classes.rowCell}}
                    //noDelete={customer_id !== customerFormId}
                    mutationMode="pessimistic" //Подтвердить удаление
                    undoable
                    createForm={<ListEditForm submitOnEnter={false}
                                              relaited_id={relaited_id}/>}
                    editForm={<ListEditForm submitOnEnter={false}
                                            relaited_id={relaited_id}/>}
                    //rowStyle={postRowStyle}
                >
                    {columns}
                </MyEditableDatagridForReference>

            </ReferenceManyField>

        </div>
    )
}
export default RelatedTradeMarks;